import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MedIconContractComponent } from "./med-icon-contract.component";

@NgModule({
  declarations: [
    MedIconContractComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    MedIconContractComponent,
  ],
})
export class MedIconContractModule { }
